<template>
  <div class="editorial-smart-link-list">
    <el-button
      :disabled="disabled"
      type="primary"
      icon="el-icon-edit"
      @click="addSmartLink"
    >Add Smart Link</el-button>
    <ul>
      <editorial-smart-link-item
        v-for="link in smartLinks"
        :key="link.id"
        :smart-link="link"
        :disabled="disabled"
        @remove="removeSmartLink"
        @update="updateSmartLink"
      />
    </ul>
  </div>
</template>

<script>
import EditorialSmartLinkItem from './EditorialSmartLinkItem.vue'
import { getRandomHash } from '../../../utils/helper'

export default {
  name: 'EditorialSmartLinkList',
  components: {
    EditorialSmartLinkItem,
  },
  props: {
    smartLinks: {
      type: Array,
      default: () => [],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSmartLinkModel() {
      return {
        id: getRandomHash(),
        text: '',
        link: '',
      }
    },
    addSmartLink() {
      this.$emit('add', this.getSmartLinkModel())
    },
    removeSmartLink(smartLink) {
      this.$emit('remove', smartLink)
    },
    updateSmartLink(smartLink) {
      this.$emit('update', smartLink)
    },
  },
}
</script>

<style lang="scss" scoped>
.editorial-smart-link-list {
  padding: 5px 0;
}
.el-button {
  margin-bottom: 8px;
}

ul {
  padding: 0;
  margin: 0;
}
</style>
